/* eslint-disable react/forbid-elements */
import { DpButtonForm } from '@/components/blocks/DpLibrary/DpButtonForm';
import { DpDpValeForm } from '@/components/blocks/DpLibrary/DpDpValeForm';
import { DpInputTextField } from '@/components/blocks/DpLibrary/DpInputTextField';
import { Img } from '@/components/blocks/MaterialImage';
import { Box, Grid, Stack, SxProps, useMediaQuery, useTheme, Theme } from '@mui/material';
import React, { useState } from 'react';
import { DpDrawer } from '@/components/blocks/DpDrawer';
import {
	DPVALE_FORM_CLIENT_ID,
	DPVALE_FORM_DE_EXTERNAL_KEY,
	DPVALE_FORM_ACTION,
	DPVALE_FORM_RETURN_XML,
	DPVALE_FORM_SUCCESS_URL,
	DPVALE_FORM_ERROR_URL,
	DPVALE_FORM_URL,
} from '@/data/config/DPVALE_FORM';
import { combineSX } from '@/utils/combineSX';

export const DpBannerChildren = ({
	children,
	image,
	sxcontainer,
	sx,
	sximage,
}: {
	image:
		| {
				mobile: string;
				desktop: string;
		  }
		| string;
	children: React.ReactNode;
	sxcontainer?: SxProps<Theme>;
	sx?: SxProps<Theme>;
	sximage?: SxProps<Theme>;
}) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const getImage = typeof image === 'string' ? image : isMobile ? image?.mobile : image?.desktop;

	return (
		<Grid
			container
			width="100vw"
			sx={combineSX([
				{
					[theme.breakpoints.down('md')]: {
						flexDirection: 'column-reverse',
					},
				},
				sxcontainer,
			])}
		>
			<Grid
				item
				xs={12}
				md={5}
				sx={combineSX([
					{
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						bgcolor: '#ffffff',
						px: { xs: '20px', md: '85px' },
						py: { xs: '40px', md: '20px' },
					},
					sx,
				])}
			>
				{children}
			</Grid>
			<Grid xs={12} md={7}>
				<Img
					src={getImage}
					sx={combineSX([
						{
							display: 'block',
							width: '100%',
							height: '100%',
							objectFit: 'cover',
							objectPosition: 'center',
						},
						sximage,
					])}
				/>
			</Grid>
		</Grid>
	);
};

export const DpBannerForm = ({
	children,
	image,
	placeholderinput,
	labelbutton,
	type,
	title,
	formfields,
}: {
	image:
		| {
				mobile: string;
				desktop: string;
		  }
		| string;
	children: React.ReactNode;
	placeholderinput?: string;
	labelbutton?: any;
	type?: string;
	title?: string;
	formfields?: any;
}) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const getImage = typeof image === 'string' ? image : isMobile ? image?.mobile : image?.desktop;

	const childrenArray = React.Children.toArray(children).filter((item) => typeof item === 'object');

	const [email, setEmail] = useState<any>('');
	const [openModal, setOpenModal] = useState<boolean>(false);

	const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setEmail(event.target.value);
	};

	const validateEmail = (email: string) => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	};

	const handleSubmitClick = () => {
		if (type === 'scroll') {
			window.scrollBy({ top: 500, behavior: 'smooth' });
		} else if (type === 'submit') {
			if (!email) {
				return;
			}

			if (!validateEmail(email)) {
				return;
			}

			const body = new URLSearchParams({
				_clientID: DPVALE_FORM_CLIENT_ID,
				_deExternalKey: DPVALE_FORM_DE_EXTERNAL_KEY,
				_action: DPVALE_FORM_ACTION,
				_returnXML: DPVALE_FORM_RETURN_XML,
				_successURL: DPVALE_FORM_SUCCESS_URL,
				_errorURL: DPVALE_FORM_ERROR_URL,
				Email: email,
			}).toString();

			fetch(DPVALE_FORM_URL, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body,
			})
				.then((response) => {
					if (response.ok) {
					} else {
						return response.text().then((text) => {
							throw new Error(`Error en la respuesta: ${response.status} - ${text}`);
						});
					}
				})
				.catch((error) => {
					console.error('Error al enviar el correo:', error);
				});
		} else if (type === 'modal') {
			setOpenModal(true);
		}
	};

	const handleCloseModal = () => {
		setOpenModal(false);
	};
	return (
		<Grid
			container
			width="100vw"
			sx={{
				[theme.breakpoints.down('md')]: {
					flexDirection: 'column-reverse',
				},
			}}
		>
			<Grid
				item
				xs={12}
				md={5}
				sx={(theme) => ({
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					bgcolor: '#29292C',
					px: '85px',
					py: '20px',
					[theme.breakpoints.down('sm')]: {
						px: '20px',
						py: '40px',
					},
				})}
			>
				{childrenArray}
				{placeholderinput ? (
					<DpInputTextField
						value={email}
						onChange={handleInputChange}
						placeholder={placeholderinput}
						sx={{
							'& .MuiOutlinedInput-root': {
								'&.Mui-focused fieldset': {
									borderColor: 'transparent',
								},
							},
						}}
					/>
				) : null}
				{labelbutton ? (
					<DpButtonForm
						label={labelbutton}
						sx={{
							backgroundColor: '#F1F1F1',
							color: '#29292C',
							'&:hover': { backgroundColor: '#E1E1E1' },
						}}
						onClick={handleSubmitClick}
					/>
				) : null}
			</Grid>
			<Grid xs={12} md={7}>
				<Img
					src={getImage}
					sx={{
						display: 'block',
						width: '100%',
						height: '100%',
						objectFit: 'cover',
						objectPosition: 'center',
					}}
				/>
			</Grid>
			<Stack width={'100%'} sx={{ height: '100%' }}>
				{title && formfields ? (
					<DpDrawer title={title} open={openModal} onClose={handleCloseModal}>
						<Box sx={{ marginTop: '10px' }}>
							<DpDpValeForm formfields={formfields} />
						</Box>
					</DpDrawer>
				) : null}
			</Stack>
		</Grid>
	);
};
